/**
 * 중첩 `el-drawer`(3200)·select popper(3600) 위에 확인창을 띄운다.
 * EP MessageBox는 `visible` 시 `nextZIndex()`로 options.zIndex를 덮어쓰므로
 * `DRAWER_MESSAGE_BOX_MODAL_CLASS` + global CSS `!important`도 함께 쓴다.
 */
export const DRAWER_MESSAGE_BOX_Z_INDEX = 10000;

/** `ElMessageBox` `modalClass` — `styles/index.css` 와 쌍으로 사용 */
export const DRAWER_MESSAGE_BOX_MODAL_CLASS = 'ax-drawer-stack-message-box';

/** Drawer 닫기 확인(`ElMessageBox`)용 z-index (options 전달용) */
export function drawerMessageBoxZIndex(drawerZIndex?: number): number {
  return Math.max((drawerZIndex ?? 2000) + 500, DRAWER_MESSAGE_BOX_Z_INDEX);
}
